import * as React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { StyledEngineProvider } from '@mui/material/styles'
import { ThemeProvider } from '@mui/material'
import theme from 'app/theme'
import CssBaseline from '@mui/material/CssBaseline'
import { reactPlugin } from 'AppInsight'
import { AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js'
import AppInsightErrorRedirect from 'app/error/AppInsightErrorRedirect'
import Auth0Provider from 'auth/Auth0Provider'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { SnackbarProvider } from 'snackbar/SnackbarContext'

const AppProviders: React.FC<React.PropsWithChildren> = ({ children }) => {
  const queryClient = new QueryClient()

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <AppInsightsErrorBoundary onError={() => <AppInsightErrorRedirect />} appInsights={reactPlugin}>
          <Auth0Provider>
            <StyledEngineProvider injectFirst>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <SnackbarProvider>{children}</SnackbarProvider>
              </ThemeProvider>
            </StyledEngineProvider>
          </Auth0Provider>
        </AppInsightsErrorBoundary>
      </Router>
    </QueryClientProvider>
  )
}

export default AppProviders
